/*****默认参数
 @param  file   file对象
 @param  degress
            deep 压缩比例 default 0.8
 *******
 **/
function red(file,degress={}) {
  var degress = Object.assign({
    deep:0.8
  },degress);
  let self = this;
  let filename = file.name
  //判断支不支持FileReader
  if (!file || !window.FileReader) {
    return new Promise((resolve, reject) => {
      resolve('nonsupport')
    })
  }
  if (/^image/.test(file.type)) {
    /*创建一个reader
    let reader = new FileReader();
    //将图片转成base64格式
    reader.readAsDataURL(file);
    读取成功后的回调
    reader.onloadend = function (){
      let result = this.result;
      let img = new Image();
      img.src = result;
      img.onload = function(){
        let data = compress(img);
        self.imgUrl = result;
        let blob = dataURItoBlob(data);
        let formData = new FormData();
        formData.append("file", blob,filename);
        files=formData.get('file')
        console.log(files)
      }
    }*/
    return new Promise((resolve, reject) => {
      Readers(file).then((res) => {
        Imgs(res,degress).then((res2) => {
          self.imgUrl = res
          let formData = new FormData()
          formData.append("file", res2, filename)
          resolve(formData)
        })
      })
    })
  } else {
    return new Promise((resolve, reject) => {
      reject('Type error, please upload image format')
    })
  }
}
function Imgs(imgs,degress) {
  return new Promise((resolve, reject) => {
    let img = new Image()
    img.src = imgs
    img.onerror = function () {
      reject('nonsupport')
    }
    img.onload = function () {
      let data = compress(img,degress)
      let blob = dataURItoBlob(data);
      resolve(blob)
    }
  })
}
function Readers(file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onloadend = function () {
      resolve(this.result)
    }
  })
}
function compress(img,degress) {
  let canvas = document.createElement("canvas");
  let ctx = canvas.getContext("2d");
  let initSize = img.src.length;
  let width = img.width;
  let height = img.height;
  canvas.width = width;
  canvas.height = height;
  // 铺底色
  ctx.fillStyle = "#fff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(img, 0, 0, width, height);

  //进行最小压缩
  let ndata = canvas.toDataURL("image/jpeg", degress.deep);
  return ndata;
}
// base64转成bolb对象
function dataURItoBlob(base64Data) {
  let byteString;
  if (base64Data.split(",")[0].indexOf("base64") >= 0)
    byteString = atob(base64Data.split(",")[1]);
  else byteString = unescape(base64Data.split(",")[1]);
  let mimeString = base64Data
    .split(",")[0]
    .split(":")[1]
    .split(";")[0];
  let ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ia], { type: mimeString });
}
export default {
  red
}
